// extracted by mini-css-extract-plugin
export default {"mySwiper":"style_mySwiper__5rDVO","swiperWrapper":"style_swiperWrapper__Rhaql"};